module.exports = __webpack_public_path__ + "static/mini-meditation-8a02a16a34050030230572b96ff6dbf3.png";